import { useEffect, useState } from "react";
import { usePopUpsV2 } from "components/PopUpManagerV2/hooks/usePopUpsV2";
import { useAppSelector } from "hooks";
import { selectPWAState } from "redux/slices/pwa";
import { usePushShouldShowPopup } from "./usePushShouldShowPopup";

/**
 * Triggers the PWA permissions popup when the app is running
 * in standalone (installed) mode and push notifications are
 * supported but not yet subscribed.
 */
export const usePushTriggerPermissions = (): void => {
	const { open } = usePopUpsV2();
	const { hasCompletedPWAInit } = useAppSelector(selectPWAState);
	const shouldShowPopup = usePushShouldShowPopup();
	const [showPopup, setShowPopup] = useState(false);

	useEffect(() => {
		if (showPopup) {
			open({
				variant: "push-permissions-popup",
				id: "push-permissions-popup",
				replaceIfExists: true
			});
		}
	}, [showPopup]);

	useEffect(() => {
		if (typeof window === "undefined") {
			return;
		}

		if (!hasCompletedPWAInit) {
			return;
		}

		setShowPopup(shouldShowPopup);
	}, [hasCompletedPWAInit, shouldShowPopup]);
};
